export default "__VITE_ASSET__Bh2$zlb2__"